import React from 'react';
import { Container, Button, Row, Col } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import ImageAnmeldungPlaceholder from '../../images/anmeldung/anmeldung-dummy.png';

function Vorteile() {

  const ImagesTisch = [
        require('../../images/anmeldung/vortrag-01.jpg'),
        // require('../../images/anmeldung/vortrag-02.jpg'),
        // require('../../images/anmeldung/vortrag-03.jpg'),
        // require('../../images/anmeldung/vortrag-04.jpg'),
        // require('../../images/anmeldung/vortrag-05.jpg'),
        // require('../../images/anmeldung/vortrag-06.jpg'),
        // require('../../images/anmeldung/vortrag-07.jpg'),
        // require('../../images/anmeldung/vortrag-08.jpg'),
        // require('../../images/anmeldung/vortrag-09.jpg'),
        // require('../../images/anmeldung/vortrag-10.jpg'),
        // require('../../images/anmeldung/vortrag-11.jpg'),
        // require('../../images/anmeldung/vortrag-12.jpg'),
  ]

  const ImagesTischElement = ImagesTisch[(Math.floor(Math.random() * ImagesTisch.length))];

  return (
    <React.Fragment>

      <div className='text-center'>
        <img src={ImageAnmeldungPlaceholder}
          className='d-lg-none img-fluid ImageAnmeldung mb-3'
          alt='Multi-Pressekonferenz'
          style={{ backgroundImage: `url("${ImagesTischElement}")` }}
        />
      </div>
      <div className="ImageTisch" style={{ backgroundImage: `url("${ImagesTischElement}")` }}>
        <Container>
          <Row className='pt-lg-4'>
            <Col xs={12} lg={6}>
              <h1 className="pb-4">Ihre Vorteile auf einen Blick:</h1>
              <ul style={{ listStyle: 'none' }}>
                <li style={{ marginBottom: '10px' }}>✅ Direkter Zugang zu wichtigen Fachredaktionen</li>
                <li style={{ marginBottom: '10px' }}>✅ Persönliche Gespräche statt unpersönlicher Pressemitteilungen</li>
                <li style={{ marginBottom: '10px' }}>✅ Höhere Sichtbarkeit in relevanten Fachmedien</li>
                <li style={{ marginBottom: '10px' }}>✅ Effizientes Networking an zwei kompakten Veranstaltungstagen</li>
                <li style={{ marginBottom: '10px' }}>✅ Nachhaltige Medienkontakte für zukünftige Berichterstattung</li>
              </ul>
              <br/>
              <LinkContainer to="/Anmeldung">
                <Button className="mb-3" variant='rbs-button-orange rbs-action-buttons' size='lg'>Jetzt Teilnahme sichern</Button>
              </LinkContainer>
            </Col>
          </Row>
        </Container>
      </div>     
    </React.Fragment>
  )
}

export default Vorteile;